import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const base = `${u}/projects`;

// ── Projects ──────────────────────────────────────────────────────────────────

export const getAllProjects = () =>
  apiFetch(base).then(r => r.ok ? r.json() : Promise.reject(r));

export const getProject = (id) =>
  apiFetch(`${base}/${id}`).then(r => r.ok ? r.json() : Promise.reject(r));

export const createProject = (data) =>
  apiFetch(base, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) })
    .then(r => r.ok ? r.json() : Promise.reject(r));

export const updateProject = (id, data) =>
  apiFetch(`${base}/${id}`, { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) })
    .then(r => r.ok ? r.json() : Promise.reject(r));

export const deleteProject = (id) =>
  apiFetch(`${base}/${id}`, { method: "DELETE" });

// ── Tasks ─────────────────────────────────────────────────────────────────────

export const getProjectTasks = (projectId) =>
  apiFetch(`${base}/${projectId}/tasks`).then(r => r.ok ? r.json() : Promise.reject(r));

export const createPlannerItem = (data) =>
  apiFetch(`${u}/planner`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) })
    .then(r => r.ok ? r.json() : Promise.reject(r));

export const updatePlannerStatus = (id, status) =>
  apiFetch(`${u}/planner/${id}/status`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ status })
  }).then(r => r.ok ? r.json() : Promise.reject(r));

export const updatePlannerItem = (id, data) =>
  apiFetch(`${u}/planner/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  }).then(r => r.ok ? r.json() : Promise.reject(r));

export const deletePlannerItem = (id) =>
  apiFetch(`${u}/planner/${id}`, { method: "DELETE" });

// ── Logs ──────────────────────────────────────────────────────────────────────

export const getProjectLogs = (projectId) =>
  apiFetch(`${base}/${projectId}/logs`).then(r => r.ok ? r.json() : Promise.reject(r));

export const createLog = (projectId, data) =>
  apiFetch(`${base}/${projectId}/logs`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) })
    .then(r => r.ok ? r.json() : Promise.reject(r));

export const updateLog = (projectId, logId, data) =>
  apiFetch(`${base}/${projectId}/logs/${logId}`, { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) })
    .then(r => r.ok ? r.json() : Promise.reject(r));

export const deleteLog = (projectId, logId) =>
  apiFetch(`${base}/${projectId}/logs/${logId}`, { method: "DELETE" });
